import {
  BrowserRouter,
  Routes as Router,
  Route,
  Outlet,
} from "react-router-dom";
import Login from '../components/login'
import Forget from '../components/forget'
import Reset from '../components/reset'
import { Support } from "../components/suport";

export function Routes() {
  return (
    <BrowserRouter>
      <Router>
        <Route element={<>
          <Support >
            <Outlet />
          </Support>
        </>}>
          <Route path="/" element={<Login />} />
          <Route path="/forget" element={<Forget />} />
          <Route path="/reset" element={<Reset />} />
          <Route path="*" element={<Login />} />
        </Route>
      </Router>
    </BrowserRouter>
  )
}
